import { useMutation } from '@tanstack/react-query'
import { useState } from 'react'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? 'https://intent-dashboard-ingestion.saad-saziz.workers.dev'
const STORAGE_KEY = 'intent_dashboard_session'

export function useDashboardAuth() {
  const [token,setToken]=useState<string|null>(()=>localStorage.getItem(STORAGE_KEY))
  const [sessionVersion,setSessionVersion]=useState(0)
  const loginMutation=useMutation({
    mutationFn:async(password:string)=>{
      const response=await fetch(`${API_BASE_URL}/auth/login`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({password}),cache:'no-store'})
      const body=await response.json().catch(()=>({})) as {token?:string;error?:string}
      if(!response.ok||!body.token) throw new Error(body.error??`Login failed with ${response.status}`)
      return body.token
    },
    onSuccess:session=>{localStorage.setItem(STORAGE_KEY,session);setToken(session);setSessionVersion(value=>value+1)},
  })
  const logout=()=>{localStorage.removeItem(STORAGE_KEY);setToken(null);setSessionVersion(value=>value+1);loginMutation.reset()}
  return {token,sessionVersion,login:loginMutation.mutate,isLoggingIn:loginMutation.isPending,loginError:loginMutation.error instanceof Error?loginMutation.error.message:null,logout}
}
